export const environment = {
  production: true,
  restaurantId: 'fattyPatty',
  firebaseConfig: {
    apiKey: 'AIzaSyBwFlXVmafGVfCXS0fJJ26tuX-5vAmIblE',
    authDomain: 'fattypatty-prod.firebaseapp.com',
    projectId: 'fattypatty-prod',
    storageBucket: 'fattypatty-prod.firebasestorage.app',
    messagingSenderId: '611419984021',
    appId: '1:611419984021:web:8ec93a376aea3e2b37cb9c',
    measurementId: 'G-390V9DBLH3',
  },
  headerTitle: 'fatty Patty',
  apiUrl: 'https://us-central1-wl-restaurants.cloudfunctions.net/apiv3',
  mainColor: '#FF7A00',
  facebookLink: 'https://www.facebook.com/TheFattyPattyBurger',
  twitterLink: '',
  instagramLink: 'https://www.instagram.com/thefattypattyburger/',
  yelpLink:
    'https://www.yelp.com/biz/taqwas-bakery-and-restaurant-greenfield?osq=Taqwa',
  phoneNumber: '+1 (414) 550 55 55',
  address: '4651 S 27th St, Greenfield, WI 53221',
  email: 'info@TT.com',
  about: `At a young age, the founders of fattyPattyDev & Restaurant
    discovered the importance of having the right ingredients to
    create the perfect recipe. Taqwa and her husband, the
    restaurant founders, collaborated and utilized their
    techniques to craft delicious Middle Eastern cuisine that
    delighted their loved ones.`,

  isRoot: false,
  primaryColor: '#C7A17A',
  secoundaryColor: '#FAFAFA',
  darkGreyColor: '#302F3C',
  darkBlueColor: '#172B4D',
  grayBlueColor: '#7A869A',
  darkgrayBlueColor: '#323643',
  footerColor: '#2B2B2B',
  shapeBlueColor: '#42526E',
  appGooglePayLink: '',
  appappleStoreLink: '',
  currency: ' $ ',

  squareApplicationId: 'sq0idp-Wut1tAvXiHD7x1oWfQ8N9g',
  squareLocationId: 'LAKV3E16Z8EZC',

  googleMapsApiKey: 'AIzaSyA_aR8DfVh495HpyDSzWhyJThTVZyFWno4',

  squareScriptUrl: 'https://web.squarecdn.com/v1/square.js',
};
